import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Partner} from '../../../../models/partner/partner';
import {PartnerService} from '../../../../services/partner/partner.service';
import {ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {LoaderService} from '../../../../services/loader/loader.service';
import { NgClass, NgOptimizedImage } from '@angular/common';
import {BehaviorSubject} from 'rxjs';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {ActivityService} from '../../../../services/crm/activity/activity.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {ConfirmService} from '../../../../services/confirm/confirm.service';
import {IsGrantedDirective} from '../../../../directives/is-granted/is-granted.directive';
import {ImageService} from '../../../../services/image/image.service';
import {PartnerActivityFormComponent} from '../partner-activity-form/partner-activity-form.component';
import {TranslatePipe} from '@ngx-translate/core';
import {AuthService} from '../../../../services/auth/auth.service';
import {IsGranted} from '../../../../decorator/is-granted';
import {AffiliateUsersComponent} from '../affiliate-users/affiliate-users.component';

@Component({
  selector: 'app-partner-tab',
  imports: [
    NgClass,
    NgOptimizedImage,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    IsGrantedDirective,
    TranslatePipe
],
  templateUrl: './partner-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-tab.component.scss'
})
@IsGranted(['PARTNER_VIEW'])
export class PartnerTabComponent implements OnInit {

  protected partner: Partner | null = null;

  partnerSubject = new BehaviorSubject<Partner | null>(null);

  constructor(
    protected partnerService: PartnerService,
    protected imageService: ImageService,
    private activityService: ActivityService,
    private route: ActivatedRoute,
    private router: Router,
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private confirm: ConfirmService,
    private auth: AuthService
  ) {
  }

  ngOnInit(): void {
    this.partnerSubject.subscribe((partner: Partner | null) => {
      this.partner = partner;
    });

    const id = Number(this.route.snapshot.paramMap.get('partnerId'));

    if (id) {
      this.fetchPartner(id);
    }
  }

  getActiveMenuClass(route: string): string {
    return this.router.url.includes(route) ? 'active' : '';
  }

  fetchPartner(id: number): void {
    // this.loader.startLoading();
    this.partnerService.findOneById(id, {groups: 'contacts,image,documents,document,advertisingPlatforms'}).subscribe(partner => {
      this.partnerSubject.next(partner);
      // this.loader.stopLoading();
    });
  }

  openActivityForm(type: string): void {
    this.dialog.openDialog(PartnerActivityFormComponent, {
      data: {
        type,
        partner: this.partner
      },
      backdrop: false
    }).subscribe(() => {
      this.activityService.activitySubject.next();

      if (this.partner && this.partner.id) {
        this.router.navigateByUrl(`/partners/${this.partner.id}/activity`).then();
      }
    });
  }

  convertProspect(): void {
    this.confirm.open('Do you wish to convert this prospect?').subscribe((result: boolean) => {

      if (result && this.partner && this.partner.id) {
        this.partnerService.update(this.partner.id, {prospect: false}).subscribe(() => {
          if (this.partner) {
            this.partner.prospect = false;
          }

          this.snackbar.success('The prospect was converted successfully.');
        });
      }
    });
  }

  isAffiliate(): boolean {
    return this.partner?.isAffiliate() ?? false;
  }

  isGranted(rights: string[]): boolean {
    return this.auth.hasRolesSync(rights);
  }

  login(): void {
    if (this.partner && this.partner.id) {
      this.partnerService.login(this.partner.id).subscribe((data) => {
        const url = data.url.trimEnd('/') + '/login?token=' + encodeURIComponent(data.token) + '&expireAt=' + encodeURIComponent(data.expireAt);
        window.open(url);
      });
    }
  }

  openAffiliateUsersModal(): void {
    this.dialog.openDialog(AffiliateUsersComponent, {
      data: this.partner,
      class: 'modal-lg'
    }).subscribe();
  }
}
